import { Injectable, Inject } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router'; // ActivatedRoute se usa solo para tipos
import { filter, map } from 'rxjs/operators';
import { DOCUMENT } from '@angular/common';
import { environment } from '../../environments/environment';

declare const gtag: Function;

@Injectable({
  providedIn: 'root'
})
export class SeoAnalyticsService {

  constructor(
    private titleService: Title,
    private metaService: Meta,
    private router: Router,
    // Quitamos la inyección de ActivatedRoute del constructor para evitar confusiones
    @Inject(DOCUMENT) private document: Document
  ) { }

  public init() {
    this.setupGoogleAnalytics();
    this.trackNavigationEvents();
  }

  private setupGoogleAnalytics() {
    if (!environment.googleAnalyticsId) {
      return;
    }

    const script = this.document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${environment.googleAnalyticsId}`;
    this.document.head.appendChild(script);

    const configScript = this.document.createElement('script');
    configScript.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', '${environment.googleAnalyticsId}', { 'send_page_view': false });
    `;
    this.document.head.appendChild(configScript);
  }

  private trackNavigationEvents() {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      map(() => {

        let child = this.router.routerState.root;

        while (child.firstChild) {
          child = child.firstChild;
        }

        return {
          title: child.snapshot.data['title'],
          noindex: child.snapshot.data['noindex']
        };
      })
    ).subscribe(({ title, noindex }) => {


      if (title) {
        this.titleService.setTitle(title);
      }

      // Actualizar meta robots basado en noindex
      if (noindex) {
        this.metaService.updateTag({ name: 'robots', content: 'noindex, nofollow' });
      } else {
        this.metaService.updateTag({ name: 'robots', content: 'index, follow' });
      }

      if (environment.googleAnalyticsId && typeof gtag !== 'undefined') {
        gtag('config', environment.googleAnalyticsId, {
          'page_path': this.router.url,
          'page_title': title || 'Sin Título'
        });
      }
    });
  }
}